// PetarLubardaBiography.tsx
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  color: dimgray;
  font-family: "Arial", sans-serif;
  line-height: 1.6;
  font-size: 14px;

  @media (max-width: 768px) {
    padding-top: 60px; /* dodatni prostor za fiksiran img */
  }
`;

const Bold = styled.b``;
//const Italic = styled.i``;

const Paragraph = styled.p`
  margin: 12px 0;
`;

const SavaSumanovic: React.FC = () => {
  return (
    <Wrapper>
      <Paragraph>
        <Bold>Sava Šumanović </Bold>
        je rođen 22. januara 1896. u Vinkovcima u imućnoj građanskoj porodici,
        Perside i Milutina Šumanovića. Posle ranog očevog penzionisanja 1900.
        porodica se vraća u Šid, gde Sava pohađa osnovnu školu.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1906–1914</Bold>
        <br />
        Upisuje Realnu gimnaziju u Zemunu. Crtanje mu predaje profesor Isidor
        Jung. Kod istog profesora pohađa i privatne časove na kojima se upoznaje
        sa impresionističkim načinom slikanja, umetnošću Sezana i Van Goga.
        Druguje sa Slavkom Vorkapićem. Leta provodi u Šidu i Gracu. Gimnaziju
        završava 1914.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1914–1918</Bold>
        <br />
        Polaže prijemni ispit i upisuje Višu školu za umjetnost i obrt u
        Zagrebu. U klasi je profesora Otona Ivekovića i Menci Klement Crnčića.
        Druži se i prijatelj je sa Marijanom Trepšeom, Đurom Tiljkom, Milanom
        Štajnerom, Hinkom Junom, Srećkom Sabljakom. Prvi put grupno izlaže na
        Školskoj izložbi 1916. Samostalno (sa B. Carom) u Ulrihovom salonu 1918.
        Iste godine završava školu i iznajmljuje atelje u Šubićevoj 8a.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1919–1920</Bold>
        <br />
        Slika sa Milanom Štajnerom. Druži se i sarađuje sa Antnom Brankom
        Šimićem. Priprema skice i velika platna za Narodno kazalište. Izveo
        scenografiju za Don Žuana V. A. Mocarta (premijera 1. juna 1920). Radi
        ilustracije, opremu knjiga, nekoliko grafika. Intenzivno slika.
        Priređuje drugu samostalnu izložbu u Zagrebu. Doživljava uspeh kod
        kritike i otkup. Stimulisan uspehom i očevom podrškom, septembra 1920.
        odlazi u Pariz. Stanuje u Rue Bréa 15. Prvih meseci intenzivno crta i
        slika, obilazi muzeje i galerije, upoznaje umetnički Pariz.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1921–1925</Bold>
        <br />
        Pohađa atelje Andre Lota. Jedan je od najboljih đaka. Intenzivno radi.
        Sa velikim oduševljenjem i brojnim slikama vraća se u Zagreb, gde
        priređuje samostalnu izložbu za koju je napisao predgovor. Doživljava
        neuspeh kod publike i nerazumevanje jednog dela stručnjaka kojima je
        kubizam i postkubizam nepoznat i stran. Satisfakciju dobija od
        eminentnih kritičara Antuna Branka Šimića, Rastka Petrovića, Ljubomira
        Micića, Pjera Križanića. Zakupljuje prostorije u Prilazu 49, mađutim
        malo slika. Izlaže na Proljetnim salonima i V jugoslovenskoj umetničkoj
        izložbi. Kraće vreme (1922) je u državnoj službi u zvanju bibliotekara
        Muzeja za umjetnost i obrt. Objavljuje u Književniku 1924. tekstove
        Slikar o slikarstvu i Zašto volim Pusenovo slikarstvo u kojima
        objašnjava svoj slikarski stav.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1925–1928</Bold>
        <br />
        Krajem maja odlazi drugi put u Pariz. Zakupljuje atelje u Rue Danwil 5.
        Crta po Lotovim sugestijama ali retko odlazi u njegov atelje. Izlaže na
        Salon des Independants i Salon d` Automne. Sa Jesenjeg salona 1926.
        francuska vlada otkupljuje sliku Akt. U kritikama ga zapažaju Florent
        Fels, Jacques Guenne, Georges Turpin. Prilikom preuređenja kafane La
        Coupole pozvan je da naslika dve kompozicije na stubovima koje su
        sačuvane. Za Salon des Independant 1927. intenzivno slika kompoziciju
        Pijani brod. Kritika pozitivno ocenjuje delo, ali su usmeni komentari
        oprečni. Negativne primedbe utiču na već oslabljenu psihičku stabilnost
        umetnika, tako da februara 1928. doživljava nervni slom. Posle kraćeg
        lečenja napušta Pariz. Brzo se oporavlja u Šidu i slika. Nastaju brojni
        pejzaži koje sa delima nastalim u Parizu 1927. i 1928. izlaže na Novom
        univerzitetu u Beogradu. Izložba je odlično prihvaćena. Zdravstveno
        stanje se poboljšava, tako da se oktobra vraća u Pariz.
      </Paragraph>
      <Paragraph>
        <Bold style={{ color: "#414141" }}>1929–1930</Bold>
        <br />
        Adaptira atelje u Rue Denfert – Rochereau. Slika cikluse aktova i
        pejzaža Pariza, Orsay-a, Aarcenilles-a. Posle uspeha 1927. cenjen je i
        pozivan. Upoznaje mnoge umetnike Pariza, prijateljuje sa Pascinom.
        Međutim, nervna napetost traje i dalje. Nakon nesporazuma sa žirijem i
        neizlaganja naJesenjem salonu, zdravlje mu se naglo pogoršava. Marta
        1930. zauvek napušta Francusku.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1930–1932</Bold>
        <br />
        Vraća se u Šid. Teško oboleo leči se tri meseca, zatim dve godine na
        klinikama u Beogradu.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1932–1939</Bold>
        <br />
        Ponovo je u Šidu koji gotovo ne napušta do smrti. Izolovan od spoljnjeg
        sveta mirno živi u rodnoj kući na selu i vraća se slikarstvu. Intenzivno
        radi. Slika motive iz Šida. Nastaju ciklusi Šidske ulice, Proleće u
        dolini Sv. Petke, Proleće u šidskim baštama,Kupačice, Aktovi.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1939</Bold>
        <br />
        Posećuje izložbu Savremenog francuskog slikarstva u Beogradu i odlučuje
        se na šestu samostalnu izložbu koju otvara septembra na Novom
        univerzitetu. Izložba sa neuobičajeno velikim brojem od 410 slika bila
        je izuzetan likovni događaj. Priznanje kritike, velika poseta, prodaja
        iznad očekivanja su krunisale povratak izolovanog slikara i potvrdile ga
        kao jednog od najvećih jugoslovenskih umetnika.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1940–1942</Bold>
        <br />
        Pozvan je na vojnu vežbu krajem januara 1941. u Osijek. Dodeljen je
        radničkom bataljonu u svojstvu crtača. Po izbijanju rata i kapitulaciji
        Jugoslavije, bataljon se u Tuzli predaje Nemcima. Kraće vreme je u
        vojnom logoru. Otpušten kući 19. aprila. Usporenim tempom i dalje slika
        ustaljene motive – šidske pejzaže, kompozicije sa aktovima, beračice,
        portrete. Uhapšen 28. avgusta 1942. i kao taoc streljan u noći između
        29. i 30. avgusta od ustaša u Sremskoj Mitrovici.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1952</Bold>
        <br />
        Majka poklanja dela Save Šumanovića i dve reprezentativne zgrade za
        memorijalni muzej. Galerija Save Šumanovića je otvorena u Šidu 21.
        septembra. Poseduje fond od 417 dela, 356 uljanih slika i 61 delo na
        papiru – crteža, akvarela i pastela.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1958</Bold>
        <br />
        Avala film iz Beograda snima dokumentarni film o Savi Šumanoviću –
        Putevi u režiji i po scenariju Aleksandra Petrovića i umetničkog
        snimatelja Nikole Majdaka.
      </Paragraph>
      <Paragraph>
        <Bold style={{ color: "#414141" }}>1960</Bold>
        <br />
        Publikovana monografija Save Šumanovića koju je napisao Dimitrije
        Bašićević u izdanju Društva historičara umjetnosti, Zagreb.
      </Paragraph>

      <Paragraph>
        <Bold style={{ color: "#414141" }}>1962</Bold>
        <br />
        Osnovan Memorijal Save Šumanovića u Šidu. Priređena komemorativna
        izložba povodom dvadesetogodišnjice smrti u Kulturnom centru u Beogradu.
        Izbor radova (66) i predgovor kataloga Momčilo Stevanović.
      </Paragraph>
      <Paragraph>
        <br />
        Biografija preuzeta iz: Radmila Matić, Biografija, u: Sava Šumanović
        1896–1942. retrospektivna izložba, Muzej savremene umetnosti, Beograd,
        april–jun 1984. str.51–52
      </Paragraph>
      <div style={{ height: "50px" }} />
    </Wrapper>
  );
};

export default SavaSumanovic;
